<template>
  <div
    class="bulk-discount"
    v-if="isBulkDiscount"
  >
    <img
      class="bulk-discount__image"
      src="@/assets/offer/apply-now.png"
      alt=""
    >
    <div>
      <p class="bulk-discount__title">
        You’ve qualified for bulk discounts. Would you like to apply?
      </p>
      <span
        class="bulk-discount__button"
        @click="showNewMessage()"
      >
        Apply Discount
      </span>
    </div>
  </div>
</template>

<script setup>
import { useIntercom } from '@/hooks/useIntercom'
import { useBulkDiscount } from '@/views/OfferView/components/hooks/useBulkDiscount'

const { isBulkDiscount } = useBulkDiscount()

const { showNewMessage } = useIntercom()
</script>

<style lang="less" scoped>
.bulk-discount {
  display: flex;
  align-items: center;
  gap: 8px;

  &__image {
    width: 36px;
    height: 36px;
  }

  &__title {
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
  }

  &__button {
    margin-top: 2px;
    display: inline-block;
    color: #007EB3;
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
